module.exports = __webpack_public_path__ + "static/media/8-4.722ff7e4.mp3";